// M7 (29 Sep 2026): jQuery, Slick and Swiper no longer load on every page. Swiper now loads only
// with the Feature Collection Slider section, and jQuery + Slick only with the Testimonials section,
// so each slider starts only when its library and its section are on the page. Before, a page
// without jQuery would stop here and the FAQ accordion and product tabs below would not work.
document.addEventListener("DOMContentLoaded", function () {
  if (!window.Swiper || !document.querySelector(".swiper-container")) return;
  var swiper = new Swiper(".swiper-container", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
      breakpoints: {
     500: {
          slidesPerView: 2, 
      },
      767: {
          slidesPerView: 4, 
      },
    },
  });
});


// Testimonial Slider

document.addEventListener("DOMContentLoaded", function () {
  if (!window.jQuery || !jQuery.fn.slick || !document.querySelector(".testimonials_slider1")) return;

$('.testimonials_slider1').slick({
    dots: false,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 5, // Show 5 slides at a time
    centerMode: true,
    centerPadding: 0,
    asNavFor: '.testimonials_slider2',
    prevArrow: '<svg class="testimonials_slider1_prev" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M24.3933 11.2044L23.8018 10.6129L14.9289 19.4857L14.9288 19.4856L14.3373 20.0772L23.8017 29.5415L24.3932 28.95L15.5205 20.0773L24.3933 11.2044Z" fill="#232323"/></svg>',
    nextArrow: '<svg class="testimonials_slider1_next" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.5177 28.9499L17.1092 29.5414L25.9821 20.6686L25.9822 20.6686L26.5737 20.0771L17.1093 10.6128L16.5178 11.2043L25.3905 20.077L16.5177 28.9499Z" fill="#232323"/></svg>',
    responsive: [
        {
            breakpoint: 1080,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
});


  $('.testimonials_slider2').slick({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    arrows: true,
    prevArrow: '<svg class="testimonials_slider1_prev" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M24.3933 11.2044L23.8018 10.6129L14.9289 19.4857L14.9288 19.4856L14.3373 20.0772L23.8017 29.5415L24.3932 28.95L15.5205 20.0773L24.3933 11.2044Z" fill="#232323"/></svg>',
    nextArrow: '<svg class="testimonials_slider1_next" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.5177 28.9499L17.1092 29.5414L25.9821 20.6686L25.9822 20.6686L26.5737 20.0771L17.1093 10.6128L16.5178 11.2043L25.3905 20.077L16.5177 28.9499Z" fill="#232323"/></svg>',
    asNavFor: '.testimonials_slider1'
  });
});


// Product TAbs Js

const tabs = document.querySelectorAll('[data-tab-target]')
const tabContents = document.querySelectorAll('[data-tab-content]')

tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    const target = document.querySelector(tab.dataset.tabTarget)
    tabContents.forEach(tabContent => {
      tabContent.classList.remove('active')
    })
    tabs.forEach(tab => {
      tab.classList.remove('active')
    })
    tab.classList.add('active')
    target.classList.add('active')
  })
})

// FAQs Accordion Js

const accordionTriggers = document.querySelectorAll('.accordion-trigger');

accordionTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
        const faqItem = trigger.parentElement.parentElement;
        const answer = faqItem.querySelector('.faq-answer');

        faqItem.classList.toggle('open');

        if (faqItem.classList.contains('open')) {
            const otherFaqItems = document.querySelectorAll('.faq-item');
            otherFaqItems.forEach(item => {
                if (item !== faqItem && item.classList.contains('open')) {
                    item.classList.remove('open');
                }
            });
        }
    });
});




